/**
 * Hook to get the current user's organization ID from Redux store
 */
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const useOrganizationId = () => {
  return useSelector(
    (state: RootState) => state.session.user?.representative?.organization_id,
  );
};
